import { useContext } from 'react';
import ConfigContext from 'app/context/config';

export default () => useContext(ConfigContext);
